import { useMemo } from 'react';
import { toDateKey, isAllDay } from '../../../../../utils/dateUtils';

/**
 * Hook to categorize assignments into all-day and timed buckets per day.
 */
export function useAssignmentGrouping(days, assignments) {
    return useMemo(() => {
        const allDay = {};
        const timed = {};
        
        days.forEach(d => {
            const key = toDateKey(d);
            allDay[key] = [];
            timed[key] = [];
        });

        (assignments || []).forEach(a => {
            if (!a.start_datetime) return;
            
            const isAD = isAllDay(a);
            const sDt = a.start_datetime;
            const eDt = a.end_datetime || sDt;

            const sDay = new Date(sDt); sDay.setHours(0,0,0,0);
            const eDay = new Date(eDt); eDay.setHours(0,0,0,0);

            days.forEach(d => {
                const key = toDateKey(d);
                if (d >= sDay && d <= eDay) {
                    if (isAD) allDay[key].push(a);
                    else timed[key].push(a);
                }
            });
        });

        let maxCount = 1;
        Object.values(allDay).forEach(list => {
            if (list.length > maxCount) maxCount = list.length;
        });

        return { allDayByKey: allDay, timedByKey: timed, maxAllDayCount: maxCount };
    }, [assignments, days]);
}
